import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
export function useAxeptio() {
  /**
   * Get axeptio consent for a specific `vendor`. Note that axeptio consent might not be collected during
   * the intial page load. To initialize third parties use `onConsent`.
   */
  function getConsent(vendor) {
    var _cookie$value;
    var cookie = useCookie('axeptio_authorized_vendors');
    var authorizedVendors = (_cookie$value = cookie.value) === null || _cookie$value === void 0 ? void 0 : _cookie$value.split(',');
    return !!(authorizedVendors !== null && authorizedVendors !== void 0 && authorizedVendors.includes(vendor));
  }

  /**
   * Executes a `callback` function only after consent for a specific `vendor` has been collected and approved.
   */
  function onConsent(vendor, callback) {
    // If the vendor is already in the axeptio cookie, execute the callback function
    if (getConsent(vendor)) {
      callback();
    } else if (window.axeptioSDK) {
      // If axeptio has already loaded, execute the callback function once consent has been collected.
      window.axeptioSDK.on('cookies:complete', function () {
        if (getConsent(vendor)) {
          callback();
        }
      });
    } else {
      // If axeptio has not been loaded, wait for its initialization and consent
      // before executing the callback function.
      window.addEventListener('axeptio:init', function () {
        var _window, _window$axeptioSDK;
        if (typeof ((_window = window) === null || _window === void 0 ? void 0 : (_window$axeptioSDK = _window.axeptioSDK) === null || _window$axeptioSDK === void 0 ? void 0 : _window$axeptioSDK.on) === 'function') {
          window.axeptioSDK.on('cookies:complete', function () {
            if (getConsent(vendor)) {
              callback();
            }
          });
        }
      }, {
        once: true
      });
    }
  }
  return {
    getConsent: getConsent,
    onConsent: onConsent
  };
}